import { EventEmitter } from "pixi.js";

export const EventBus = new EventEmitter(); 